<template>
  <div
    v-if="systemSettings?.maintenanceStatus !== MaintenanceStatus.StopLogin"
    class="flex h-screen w-full flex-col items-center justify-center gap-10"
  >
    <h2 class="text-3xl-b">{{ error?.statusCode }}</h2>
    <p class="text-xl">{{ error?.message }}</p>
    <NewBaseButton theme="primary" @click="handleError">戻る</NewBaseButton>
  </div>
  <div
    v-else
    class="flex h-screen flex-col items-center justify-center overflow-y-auto p-2"
  >
    <img
      class="w-[176px]"
      src="~/assets/images/logo-redesigner.svg?url"
      alt="ReDesigner"
    />
    <div class="mt-14 flex flex-col items-center space-y-8">
      <h1 class="text-4xl-b">
        {{ systemSettings?.title }}
      </h1>
      <p class="whitespace-pre-wrap text-center text-xl">
        {{ systemSettings?.text }}
      </p>
      <div class="text-xl">
        <p class="text-center text-xl-b">メンテナンス予定期間</p>
        <p class="text-center">{{ systemSettings?.period }}</p>
      </div>
      <a
        :href="inquiryUrl"
        target="_blank"
        class="text-xl text-primary hover:underline"
        >お問い合わせ</a
      >
    </div>
  </div>
</template>

<script setup lang="ts">
type Props = {
  error?: { statusCode: number; message: string }
}
const props = withDefaults(defineProps<Props>(), {
  error: undefined,
})

const { systemSettings } = useSystemSettings()

const handleError = () => {
  switch (props.error?.statusCode) {
    case 403:
    case 404:
      navigateTo('/home')
      break
    default:
      clearError()
  }
}

const config = useRuntimeConfig()
const inquiryUrl = `${config.public.candidateSiteBaseUrl}/inquiry`

const title = (() => {
  switch (systemSettings.value?.maintenanceStatus) {
    case MaintenanceStatus.StopLogin:
      return 'メンテナンス'
    default:
      return `${props.error?.statusCode} Error`
  }
})()

const description = (() => {
  switch (systemSettings.value?.maintenanceStatus) {
    case MaintenanceStatus.StopLogin:
      return '現在メンテナンス中です。'
    default:
      return 'お探しのページは見つかりませんでした。'
  }
})()

useHead(() => {
  return {
    title,
    meta: [
      {
        hid: 'description',
        name: 'description',
        content: description,
      },
      {
        hid: 'og-title',
        property: 'og:title',
        content: `${title} | ReDesigner`,
      },
      {
        hid: 'og-description',
        property: 'og:description',
        content: description,
      },
    ],
  }
})
</script>
